<template>
  <div class="page-root">
    <div class="welcome-card">
      <h1 class="welcome-title">Seja bem-vindo!</h1>

      <p class="welcome-text">Saudações, estamos muito felizes em tê-lo conosco.</p>
      <p class="welcome-text">
        Plataforma de negativação de dívidas que estimula o recebimento do crédito
        para qualquer segmento. Credores em geral, empresários, lojistas,
        condomínios com títulos certos, líquidos e exigíveis ora têm um serviço de
        negativação acessível, democrático, com segurança jurídica e sem burocracia.
        Recuperação de crédito com eficiência e tecnologia.
      </p>
      <p class="welcome-text">
        Para usufruir das funcionalidades do sistema, é necessário estar efetuando o
        cadastro dos dados do credor.
      </p>

      <v-btn
        color="#0052A0"
        rounded
        elevation="0"
        :to="{ name: 'Cadastro de Primeiro Credor' }"
        class="px-6 welcome-cta"
      >
        <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
        <span style="color:#FFD400;font-weight:700;font-size:13px">Cadastrar Agora</span>
      </v-btn>

      <div class="welcome-footer">
        <v-img
          class="welcome-footer__logo"
          src="../../assets/SVG/monitora-icone.svg"
          max-width="56"
          contain
        ></v-img>

        <div class="welcome-footer__right">
          <div class="welcome-footer__social">
            <v-icon size="20" color="#64748b">mdi-facebook</v-icon>
            <v-icon size="20" color="#64748b">mdi-instagram</v-icon>
            <v-icon size="20" color="#64748b">mdi-linkedin</v-icon>
          </div>
          <div class="welcome-footer__support">Suporte: 0800-000-000</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
};
</script>

<style scoped>
.page-root {
  background: linear-gradient(
    155deg,
    #ffd400 0%,
    #f9a800 38%,
    #f27c00 72%,
    #e86800 100%
  );
  min-height: 100vh;
  padding: 40px 32px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.welcome-card {
  width: 100%;
  max-width: 760px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  padding: 40px 48px;
  box-sizing: border-box;
}

.welcome-title {
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.welcome-text {
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  color: #475569;
  line-height: 1.6;
  margin-bottom: 14px;
}

.welcome-cta {
  margin: 12px 0 32px;
}

.welcome-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  border-top: 1px solid #f1f5f9;
  padding-top: 24px;
}

.welcome-footer__right {
  text-align: right;
}

.welcome-footer__social {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.welcome-footer__support {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #0052a0;
}

@media (max-width: 768px) {
  .page-root { padding: 16px; }
  .welcome-card { padding: 24px; }
  .welcome-footer { flex-direction: column; align-items: flex-start; }
  .welcome-footer__right { text-align: left; }
  .welcome-footer__social { justify-content: flex-start; }
}
</style>
